<template>
  <div class="user-info f-c">
    <div class="f-r-vc name">
      <svg-icon icon-class="avatar" class="avatar" />
      <div class="f-c">
        <div class="username">
          <span>Hello, </span> <span>{{ username }}</span>
        </div>
        <span>Thank you for your hard working at RII!</span>
      </div>
    </div>
    <basic-form
      class="basic-info"
      ref="basicInfo"
      title="Basic Info"
      :mode="FormModes.LOOSE"
      :form-params="whatToShow"
    >
      <template v-slot:actions>
        <el-button
          size="small"
          type="primary"
          plain
          @click="editing = true"
          v-if="!editing"
        >
          Edit
        </el-button>
        <el-button
          size="small"
          type="success"
          plain
          v-if="editing"
          @click="saveUserInfo"
        >
          Save
        </el-button>
        <el-button
          size="small"
          type="danger"
          plain
          v-if="editing"
          @click="editing = false"
        >
          Cancel
        </el-button>
      </template>
    </basic-form>
    <div class="features f-r-vc" style="margin-top: 15px;">
      <el-button type="primary" class="feature-button primary-bg">
        <svg-icon
          icon-class="info"
          class="svg-white-color"
          style="font-size: 18px;"
        />
        Change Password
      </el-button>
      <el-button type="primary" class="feature-button success-bg">
        <svg-icon
          icon-class="info"
          class="svg-white-color"
          style="font-size: 18px;"
        />
        Change Email
      </el-button>
      <el-button type="primary" class="feature-button warn-bg">
        <svg-icon
          icon-class="info"
          class="svg-white-color"
          style="font-size: 18px;"
        />
        Change Phone
      </el-button>
      <el-button type="primary" class="feature-button deep-green-bg">
        <svg-icon
          icon-class="info"
          class="svg-white-color"
          style="font-size: 18px;"
        />
        Change Username
      </el-button>
      <el-button type="primary" class="feature-button primary-bg">
        <svg-icon
          icon-class="info"
          class="svg-white-color"
          style="font-size: 18px;"
        />
        Change Icon
      </el-button>
    </div>
    <div class="features f-r-vc" style="margin-top: 23px;">
      <el-button type="primary" class="feature-button hash-brown-bg">
        <svg-icon
          icon-class="info"
          class="svg-white-color"
          style="font-size: 18px;"
        />
        View Role
      </el-button>
      <el-button type="primary" class="feature-button deep-green-bg">
        <svg-icon
          icon-class="info"
          class="svg-white-color"
          style="font-size: 18px;"
        />
        Contact IT
      </el-button>
      <el-button
        type="primary"
        class="feature-button danger-bg"
        @click="signOut"
      >
        <svg-icon
          icon-class="info"
          class="svg-white-color"
          style="font-size: 18px;"
        />
        Logout
      </el-button>
    </div>
    <div class="activity-list">
      <el-tabs v-model="curTab">
        <el-tab-pane
          v-for="(tab, index) in Tabs"
          :key="'order-tab-' + index"
          :label="tab"
          :name="tab"
        />
      </el-tabs>
    </div>
  </div>
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
import { FormModes } from '@/core/configs/types'
import { mapGetters } from 'vuex'
// order
import {
  UserBasicInfoWrapUp,
  UserBasicInfoModifyForm
} from '@/core/models/user'
// components
import BasicForm from '@/components/common/BasicForm.vue'
export default {
  name: 'UserInfo',
  components: {
    BasicForm
  },
  data() {
    return {
      FormModes,
      editing: false,
      curTab: ''
    }
  },
  computed: {
    ...mapGetters(['username', 'user']),
    whatToShow() {
      return this.editing ? this.editInfo : this.viewInfo
    },
    viewInfo() {
      return UserBasicInfoWrapUp(this.user)
    },
    editInfo() {
      const form = cloneDeep(UserBasicInfoModifyForm)
      Object.values(form).forEach(one => {
        one.value = this.user[one.key]
      })
      return form
    },
    Tabs() {
      return ['Activity Records', 'xxx']
    }
  },
  methods: {
    saveUserInfo() {},
    signOut() {
      const h = this.$createElement
      this.$msgbox({
        title: 'Sign out?',
        message: h('div', { class: 'f-r-hsb', style: 'margin: 0px 20px' }, [
          [1, 2, 3].map(() => {
            return h(
              'svg-icon',
              {
                style: 'width: 24px; height: 24px',
                attrs: { 'icon-class': 'run' }
              },
              ''
            )
          })
        ]),
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            this.$store.dispatch('logOut')
            this.$router.push('/login')
          }
          done()
        }
      })
        .then(action => {
          this.$message({
            type: 'info',
            message: 'action: ' + action
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.user-info {
  margin-top: 20px;

  .name {
    padding: 0 20px;
    gap: 20px;

    .avatar {
      width: 72px;
      height: 72px;
    }

    .username {
      color: rgba($color: black, $alpha: 0.65);
      font-size: 32px;
      font-weight: bolder;
    }
  }

  .basic-info {
    margin-top: 20px;

    &::v-deep .value {
      font-weight: bold;
    }
  }

  .features {
    margin: 0 20px;
    gap: 20px;

    .feature-button {
      margin-left: 0;
    }
  }

  .activity-list {
    margin: 0 20px;
    margin-top: 25px;

    @extend .global-margin;
    @extend .shadow-level-three;

    height: 500px;
    border-radius: $home-card-border-radius;
    padding: $home-card-padding-y $home-card-padding-x;
    background-color: white;
  }
}
</style>
